import { render, staticRenderFns } from "./EditQuickMenu.vue?vue&type=template&id=5ae533af&scoped=true"
import script from "./EditQuickMenu.vue?vue&type=script&lang=js"
export * from "./EditQuickMenu.vue?vue&type=script&lang=js"
import style0 from "./EditQuickMenu.vue?vue&type=style&index=0&id=5ae533af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae533af",
  null
  
)

export default component.exports